module.exports = __webpack_public_path__ + "static/media/1230_Music_Classical_HL.5e194ec3.png";